import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const isAuthenticated = () => {
    const auth = localStorage.getItem('adminAuth');
    if (!auth) return false;
    
    try {
      const parsedAuth = JSON.parse(auth);
      return parsedAuth.isAuthenticated === true;
    } catch {
      return false;
    }
  };

  return isAuthenticated() ? children : <Navigate to="/admin/login" replace />;
}

export default ProtectedRoute;